import store from '../store';

export default async function EntryMarketProfile({ next, router }) {

    store.commit('SET_PRODUCT_TYPE', 'EntryMarketProfile');
    
    if (store.getters.isAuthenticated)
        return router.push({ name: "NewMarketProfile" });
    else
        return router.push({ name: "Login" });


    return next();
}
